import EmptyPinIcon from '@jetbrains/icons/pin-empty.svg'
import PinIcon from '@jetbrains/icons/pin-filled.svg'

import {usePermission} from '../../../../../hooks/usePermission'
import {useUserDisplayName} from '../../../../../hooks/useUserDisplayName'
import type {User} from '../../../../../services/rest'
import type {BuildId, BuildTypeId, ProjectId} from '../../../../../types'
import {DialogType, Permission, stringifyId} from '../../../../../types'
import {noop} from '../../../../../utils/empty'
import CommentPopup from '../../../CommentPopup/CommentPopup'
import IconButton from '../../../IconButton/IconButton'

type Props = {
  isFinishedBuild?: boolean
  openDialog?: (dialogId: string, dialogType: DialogType) => unknown
  className?: string
  buildId: BuildId
  buildTypeId?: BuildTypeId
  projectId?: ProjectId
  isPinned?: boolean
  showEmpty?: boolean
  pinCommentText: string | null | undefined
  pinCommentTimestamp: string | null | undefined
  pinCommentUser: User | undefined
}

function PinBuild({
  buildTypeId,
  projectId,
  className,
  isFinishedBuild = true,
  isPinned,
  showEmpty,
  pinCommentText,
  pinCommentTimestamp,
  pinCommentUser,
  openDialog = noop,
  buildId,
}: Props) {
  const canPin = usePermission(Permission.PIN_UNPIN_BUILD, projectId)
  const isPinnable = isFinishedBuild && canPin
  const pinCommentUserDisplayName = useUserDisplayName(pinCommentUser)
  const handlePin: () => unknown = () => openDialog(stringifyId(buildId), DialogType.PIN)

  function getTitle(): string {
    if (!isPinnable) {
      return isPinned === true ? 'Pinned' : ''
    }

    return isPinned === true ? 'Unpin...' : 'Pin...'
  }

  const show = isPinned === true || (showEmpty === true && isPinnable)

  if (!show) {
    return null
  }

  const anchor = (
    <IconButton
      disabled={!isPinnable}
      title={getTitle()}
      primary={isPinned === true && isPinnable}
      className={className}
      onClick={handlePin}
      icon={isPinned === true ? PinIcon : EmptyPinIcon}
    />
  )
  return pinCommentTimestamp != null && pinCommentUserDisplayName != null ? (
    <CommentPopup
      buildTypeId={buildTypeId}
      anchor={anchor}
      lines={3}
      timestamp={pinCommentTimestamp}
      user={pinCommentUserDisplayName}
      text={pinCommentText}
    />
  ) : (
    anchor
  )
}

export default PinBuild
